/* eslint-disable react-hooks/exhaustive-deps */

import { AppBar, Tab, Tabs } from "@material-ui/core";
import { Modal, TabPanel, useTabStyle } from "App/Component/ui";
import React, { useEffect, useState } from "react";
import { getSearchMultiNoRujukan } from "../../../utils";

import TableListNoSEP from "../TableListRencanaKontrol/TableListNoSEP";
import TableListMultiNoRujukan from "./TableListMultiNoRujukan";

function a11yProps(index) {
  return {
    id: `tab-panel-${index}`,
    "aria-controls": `TabPanel-${index}`,
  };
}

const ModalTableListMultiNoRujukanRawatJalan = ({
  setShowModal,
  noKartu,
  formData,
  setFormData,
}) => {
  const classes = useTabStyle();
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleSelectSep = (row) => {
    setFormData({
      ...formData,
      norujukan: row.noSep,
      type_norujukan: "SEP",
      tanggal_rujukan: "",
    });
    setShowModal(false);
  };

  const handleSelectNoRujukan = (row) => {
    setFormData({
      ...formData,
      norujukan: row.noKunjungan,
      type_norujukan: "pcare",
      tanggal_rujukan: row?.tglKunjungan,
    });
    setShowModal(false);
  };

  const handleSelectNoRujukanRs = (row) => {
    setFormData({
      ...formData,
      norujukan: row.noKunjungan,
      type_norujukan: "RS",
      tanggal_rujukan: row?.tglKunjungan,
    });
    setShowModal(false);
  };

  const [rows, setRows] = useState([]);
  const [rowsRs, setRowsRs] = useState([]);

  useEffect(() => {
    setNewData();
    setNewDataRs();
  }, []);

  const setNewData = async () => {
    const multiNoRujukan = await getSearchMultiNoRujukan(noKartu);
    if (multiNoRujukan.state) {
      setRows(multiNoRujukan.data);
    } else {
      setRows([]);
    }
  };

  const setNewDataRs = async () => {
    const multiNoRujukan = await getSearchMultiNoRujukan(noKartu, "rs");
    if (multiNoRujukan.state) {
      setRowsRs(multiNoRujukan.data);
    } else {
      setRowsRs([]);
    }
  };

  return (
    <Modal title='No Rujukan' show={setShowModal} width='75%'>
      <div className={classes.root}>
        <div className={classes.rootTab}>
          <AppBar
            position='static'
            classes={{
              root: classes.appbar,
            }}>
            <Tabs
              value={value}
              onChange={handleChange}
              variant='fullWidth'
              aria-label='Tabs Input Penjualan'
              classes={{
                root: classes.tabs,
                flexContainer: classes.fixedTab,
              }}>
              <Tab
                classes={{
                  selected: classes.selected,
                  fullWidth: classes.tab,
                }}
                label='NO RUJUKAN KLINIK'
                {...a11yProps(0)}
              />
              <Tab
                classes={{
                  selected: classes.selected,
                  fullWidth: classes.tab,
                }}
                label='NO RUJUKAN RS'
                {...a11yProps(0)}
              />
              <Tab
                classes={{
                  selected: classes.selected,
                  fullWidth: classes.tab,
                }}
                label='HISTORY SEP'
                {...a11yProps(2)}
              />
            </Tabs>
          </AppBar>
          <TabPanel value={value} index={0}>
            <TableListMultiNoRujukan
              noKartu={noKartu}
              rows={rows}
              handleClickSelect={handleSelectNoRujukan}
            />
          </TabPanel>
          <TabPanel value={value} index={1}>
            <TableListMultiNoRujukan
              noKartu={noKartu}
              rows={rowsRs}
              handleClickSelect={handleSelectNoRujukanRs}
            />
          </TabPanel>
          <TabPanel value={value} index={2}>
            <TableListNoSEP
              noBpjs={noKartu}
              handleClickSelect={handleSelectSep}
            />
          </TabPanel>
        </div>
      </div>
    </Modal>
  );
};

export default ModalTableListMultiNoRujukanRawatJalan;
